import styles from './StatStripCell.module.css';

interface StatStripCellProps {
  caption?: string;
  label?: string;
  value?: string;
}

export function StatStripCell({ caption, label, value }: StatStripCellProps) {
  if (label) {
    return (
      <div className={styles.labelCell}>
        <p>{label}</p>
      </div>
    );
  }

  return (
    <div className={styles.cell}>
      <p className={styles.value}>{value}</p>
      <p className={styles.caption}>{caption}</p>
    </div>
  );
}
